/**
 * Template - Data mapper for RFI2 - Finished Good
 * Section UID (in template) : Section Path in data
 */
export const rfi2FinishedGoodSectionMapper = {
  // Business Capability
  factory_capabilities:
    'dynamic_sections.business_capability.factory_capabilities',
  upload_documents_supporting_factory_capabilities:
    'dynamic_sections.business_capability.upload_documents_supporting_factory_capabilities',
  certifications: 'dynamic_sections.business_capability.certifications',
  in_house_manufacturing_process:
    'dynamic_sections.business_capability.in_house_manufacturing_process',
  internal_testing_methods:
    'dynamic_sections.business_capability.internal_testing_methods',
  material_capability:
    'dynamic_sections.business_capability.material_capability',
  record_packaging_capabilities:
    'dynamic_sections.business_capability.record_packaging_capabilities',
  additional_business_capabilities:
    'dynamic_sections.business_capability.additional_business_capabilities',
  beauty_formulation_capabilities:
    'dynamic_sections.business_capability.beauty_formulation_capabilities',
  beauty_packaging_capabilities:
    'dynamic_sections.business_capability.beauty_packaging_capabilities',
  additional_facility_information:
    'dynamic_sections.business_capability.additional_facility_information',

  //packaging rfi3 fields
  primary_packaging_capabilities:
    'dynamic_sections.business_capability.primary_packaging_capabilities',
  primary_materials: 'dynamic_sections.business_capability.primary_materials',
  primary_packaging_format:
    'dynamic_sections.business_capability.primary_packaging_format',
  quality_assurance: 'dynamic_sections.business_capability.quality_assurance',
  packaging_equipment:
    'dynamic_sections.business_capability.packaging_equipment',
  packaging_equipment_capabilities:
    'dynamic_sections.business_capability.packaging_equipment_capabilities',
  packaging_equipment_capabilities_for_plastics:
    'dynamic_sections.business_capability.packaging_equipment_capabilities_for_plastics',
  packaging_equipment_rfid:
    'dynamic_sections.business_capability.packaging_equipment_rfid',
  color_and_production_management:
    'dynamic_sections.business_capability.color_and_production_management',

  // Supply Chain
  shipping_information: 'dynamic_sections.supply_chain.shipping_information',

  // Responsible Sourcing
  responsible_sourcing_sustainability:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability',
  food_and_beverages:
    'dynamic_sections.responsible_sourcing.food_and_beverages',

  // Other Information
  additional_factory_information:
    'dynamic_sections.other_information.additional_factory_information',
  key_factory_personnel:
    'dynamic_sections.other_information.key_factory_personnel',
  fnb_mandatory_contacts:
    'dynamic_sections.other_information.fnb_mandatory_contacts',
  employee_information:
    'dynamic_sections.other_information.employee_information',
  financial_information:
    'dynamic_sections.other_information.financial_information',
  factory_ownership: 'dynamic_sections.other_information.factory_ownership',
  factory_automation_level:
    'dynamic_sections.other_information.factory_automation_level',
  key_customer: 'dynamic_sections.other_information.key_customer',
  retailers_with_private_label:
    'dynamic_sections.other_information.retailers_with_private_label',
  gateway_decision: 'dynamic_sections.other_information.gateway_decision',

  // gmi and factory registration license
  gmi_information: 'dynamic_sections.business_capability.gmi_information',
  factory_registration_license:
    'dynamic_sections.business_capability.factory_registration_license',
  primary_material_suppliers:
    'dynamic_sections.supply_chain.primary_material_suppliers',
  responsible_sourcing_sustainability_for_packaging:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability_for_packaging',
}
